import React, { useState, useEffect } from "react";
import { initials, mockFilterOptions } from "./CandidateSearchUtils";

export const I = {
  ChevronLeft: (p) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <path d="m15 6-6 6 6 6" />
    </svg>
  ),
  Chevron: (p) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <path d="m6 9 6 6 6-6" />
    </svg>
  ),
  Refresh: (p) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <path d="M3 12a9 9 0 0 1 15.5-6.3L21 8M21 3v5h-5M21 12a9 9 0 0 1-15.5 6.3L3 16M3 21v-5h5" />
    </svg>
  ),
  Shield: (p) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6l8-3Z" />
    </svg>
  ),
  Pin: (p) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <path d="M12 22s7-7.5 7-13a7 7 0 1 0-14 0c0 5.5 7 13 7 13Z" />
      <circle cx="12" cy="9" r="2.5" />
    </svg>
  ),
  Search: (p) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <circle cx="11" cy="11" r="7" />
      <path d="m20 20-3.5-3.5" />
    </svg>
  ),
  X: (p) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <path d="M6 6l12 12M18 6 6 18" />
    </svg>
  ),
  Filter: (p) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <path d="M3 5h18l-7 9v6l-4-2v-4L3 5Z" />
    </svg>
  ),
  SortDesc: (p) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <path d="M3 6h12M3 12h8M3 18h4M17 6v12m0 0 3-3m-3 3-3-3" />
    </svg>
  ),
  Upload: (p) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <path d="M12 16V4M6 10l6-6 6 6M4 20h16" />
    </svg>
  ),
  Handshake: (p) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <path d="M11 17 8 14l4-4 3 3 6-6-3-3-6 6-3-3-6 6 3 3 4-4M14 17l3 3 3-3-3-3" />
    </svg>
  ),
  Check: (p) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <path d="m5 12 5 5L20 7" />
    </svg>
  ),
  Phone: (p) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <path d="M5 4h3l2 5-2 1a12 12 0 0 0 6 6l1-2 5 2v3a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2Z" />
    </svg>
  ),
  Document: (p) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="16" y1="13" x2="8" y2="13" />
      <line x1="16" y1="17" x2="8" y2="17" />
      <polyline points="10 9 9 9 8 9" />
    </svg>
  ),
  Send: (p) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <line x1="22" y1="2" x2="11" y2="13" />
      <polygon points="22 2 15 22 11 13 2 9 22 2" />
    </svg>
  ),
  Calendar: (p) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  ),
  CheckCircle: (p) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
      <polyline points="22 4 12 14.01 9 11.01" />
    </svg>
  ),
  Minus: (p) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  ),
  Folder: (p) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
    </svg>
  ),
  User: (p) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  ),
};

export function Avatar({ name, gradient, size = 32 }) {
  const [a, b] = gradient || ["#4d8efd", "#1F4E78"];
  return (
    <div
      className="cs-avatar"
      style={{
        width: size,
        height: size,
        fontSize: size * 0.38,
        background: `linear-gradient(135deg, ${a} 0%, ${b} 100%)`,
      }}
    >
      {initials(name)}
    </div>
  );
}

export function Badge({ tone = "gray", children }) {
  return <span className={`cs-badge cs-badge-${tone}`}>{children}</span>;
}

export function StatusBadge({ value }) {
  if (value === "ACTIVE")
    return (
      <Badge tone="blue">
        <span
          className="cs-status-dot"
          style={{ backgroundColor: "#4d8efd" }}
        />{" "}
        Active
      </Badge>
    );
  if (value === "INACTIVE")
    return (
      <Badge tone="gray">
        <span
          className="cs-status-dot"
          style={{ backgroundColor: "#9ca3af" }}
        />{" "}
        Inactive
      </Badge>
    );
  if (value === "SIGNUP")
    return (
      <Badge tone="purple">
        <span
          className="cs-status-dot"
          style={{ backgroundColor: "#8b5cf6" }}
        />{" "}
        Signup
      </Badge>
    );
  if (value === "BGVTRIGGERED")
    return (
      <Badge tone="amber">
        <span
          className="cs-status-dot"
          style={{ backgroundColor: "#f59e0b" }}
        />{" "}
        BGV Triggered
      </Badge>
    );
  if (value === "BGVFAILED")
    return (
      <Badge tone="rose">
        <span
          className="cs-status-dot"
          style={{ backgroundColor: "#f43f5e" }}
        />{" "}
        BGV Failed
      </Badge>
    );
  if (value === "BGVDELAYED")
    return (
      <Badge tone="amber">
        <span
          className="cs-status-dot"
          style={{ backgroundColor: "#d97706" }}
        />{" "}
        BGV Delayed
      </Badge>
    );
  return (
    <Badge tone="amber">
      <span className="cs-status-dot" style={{ backgroundColor: "#f59e0b" }} />{" "}
      {value || "Pending"}
    </Badge>
  );
}

export function RegBadge({ status, endDate }) {
  const map = {
    Valid: ["green", "Valid"],
    Expired: ["rose", "Expired"],
    "Not Available": ["gray", "N/A"],
  };
  const [tone, label] = map[status] || ["gray", "N/A"];
  return (
    <div style={{ lineHeight: "1.2" }}>
      <Badge tone={tone}>{label}</Badge>
      <div
        style={{
          fontSize: "10.5px",
          color: "rgba(11, 18, 32, 0.45)",
          marginTop: "2px",
        }}
      >
        {endDate || "—"}
      </div>
    </div>
  );
}

export function WorkedBadge({ count }) {
  if (count > 0)
    return (
      <span
        className="cs-badge"
        style={{
          padding: "4px 10px",
          background: "linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%)",
          color: "#065f46",
        }}
      >
        <I.Check style={{ width: "12px", height: "12px" }} /> Yes — {count}
      </span>
    );
  return (
    <span
      className="cs-badge"
      style={{ padding: "4px 10px", background: "#f3f4f6", color: "#6b7280" }}
    >
      — New
    </span>
  );
}

const optionMatchesQuery = (option, query) => {
  const label = option.toLowerCase();
  const q = query.trim().toLowerCase();
  if (!q) return true;
  if (label.includes(q)) return true;
  const tokens = q.split(/\s+/).filter(Boolean);
  if (tokens.length > 1) return tokens.every((t) => label.includes(t));
  return false;
};

const getOptionMatchRank = (option, query) => {
  const label = option.toLowerCase();
  const q = query.trim().toLowerCase();
  if (!q) return 0;

  if (label === q) return 100;
  if (label.startsWith(q)) return 80;
  if (label.includes(q)) return 60;

  const tokens = q.split(/\s+/).filter(Boolean);
  if (tokens.length > 1 && tokens.every((t) => label.includes(t))) return 40;

  return 0;
};

const MAX_VISIBLE_FILTER_CHIPS = 2;

export const FilterDropdown = ({
  filterKey,
  title,
  subtitle,
  headerRight,
  isArray = true,
  dynamicOptions,
  activeDropdown,
  setActiveDropdown,
  filters,
  setFilters,
  removeFilter,
  toggleFilter,
}) => {
  const isOpen = activeDropdown === filterKey;
  const [dropSearch, setDropSearch] = useState("");
  const [chipsExpanded, setChipsExpanded] = useState(false);
  const selectedVals = filters[filterKey] || (isArray ? [] : "");
  const selectedCount = Array.isArray(selectedVals) ? selectedVals.length : 0;

  useEffect(() => {
    if (!isOpen) {
      setDropSearch("");
    } else {
      setChipsExpanded(false);
    }
  }, [isOpen]);

  useEffect(() => {
    setChipsExpanded(false);
  }, [selectedCount, filterKey]);

  const options = dynamicOptions || mockFilterOptions[filterKey] || [];
  const query = dropSearch.trim();

  const filteredOptions = (() => {
    const valid = options.filter((o) => o && typeof o === "string");

    if (!query) return valid;

    return valid
      .filter((o) => optionMatchesQuery(o, query))
      .sort((a, b) => {
        const rankDiff =
          getOptionMatchRank(b, query) - getOptionMatchRank(a, query);
        return rankDiff !== 0 ? rankDiff : a.localeCompare(b);
      });
  })();

  const hasActiveSearch = query.length > 0;
  const noSearchResults = hasActiveSearch && filteredOptions.length === 0;
  const isAllSelected =
    isArray && options.length > 0 && selectedVals.length === options.length;
  const displayChips = isArray
    ? chipsExpanded
      ? selectedVals
      : selectedVals.slice(0, MAX_VISIBLE_FILTER_CHIPS)
    : [];
  const hiddenChipCount = isArray
    ? chipsExpanded
      ? 0
      : Math.max(0, selectedVals.length - MAX_VISIBLE_FILTER_CHIPS)
    : 0;
  const isSingleChip = isArray && selectedVals.length === 1;

  const renderFilterChip = (v, index) => (
    <span
      key={`${filterKey}-${v}-${index}`}
      className={`cs-filter-chip ${isSingleChip ? "cs-filter-chip-single" : ""}`}
    >
      <span className="cs-filter-chip-text">{v}</span>
      <span
        className="cs-chip-remove"
        onClick={(e) => {
          e.stopPropagation();
          removeFilter(filterKey, v);
        }}
      >
        <I.X style={{ width: "10px", height: "10px" }} />
      </span>
    </span>
  );

  return (
    <div className="cs-filter-col" style={{ position: "relative" }}>
      <div className="cs-filter-label-row">
        <div className="cs-filter-label-text">
          <div className="cs-filter-label-main">
            <span className="cs-filter-label-title">{title}</span>
            {subtitle && (
              <span className="cs-filter-label-sub" title={`(${subtitle})`}>
                {" "}
                ({subtitle})
              </span>
            )}
          </div>
        </div>
        {headerRight && headerRight}
      </div>
      <button
        className={`cs-filter-input ${isOpen ? "active-drop" : ""} ${chipsExpanded ? "chips-expanded" : ""}`}
        onClick={(e) => {
          e.stopPropagation();
          setChipsExpanded(false);
          setActiveDropdown(isOpen ? null : filterKey);
        }}
      >
        <div
          className={`cs-filter-chips-scroll ${chipsExpanded ? "is-expanded" : ""}`}
        >
          {isArray ? (
            selectedVals.length === 0 ? (
              <span className="cs-filter-placeholder">All</span>
            ) : (
              <>
                {displayChips.map((v, index) => renderFilterChip(v, index))}
                {hiddenChipCount > 0 && (
                  <span
                    className="cs-filter-chip cs-filter-more-chip"
                    onClick={(e) => {
                      e.stopPropagation();
                      setActiveDropdown(null);
                      setChipsExpanded(true);
                    }}
                  >
                    <span className="cs-filter-chip-text">
                      +{hiddenChipCount}
                    </span>
                  </span>
                )}
                {chipsExpanded &&
                  selectedVals.length > MAX_VISIBLE_FILTER_CHIPS && (
                    <span
                      className="cs-filter-chip cs-filter-more-chip"
                      onClick={(e) => {
                        e.stopPropagation();
                        setChipsExpanded(false);
                      }}
                    >
                      <span className="cs-filter-chip-text">Show less</span>
                    </span>
                  )}
              </>
            )
          ) : selectedVals && selectedVals !== "All" ? (
            renderFilterChip(selectedVals, 0)
          ) : (
            <span className="cs-filter-placeholder">All</span>
          )}
        </div>
        <div className={`cs-filter-arrow ${isOpen ? "open" : ""}`}>
          <I.Chevron
            className="cs-filter-arrow-icon"
            style={{ width: "16px", height: "16px" }}
          />
        </div>
      </button>

      {isOpen && (
        <div
          className="cs-dropdown-menu"
          onClick={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
        >
          <div className="cs-dropdown-search">
            <label className="cs-dropdown-search-inner">
              <I.Search
                style={{
                  width: "14px",
                  height: "14px",
                  color: "rgba(11, 18, 32, 0.4)",
                }}
              />
              <input
                value={dropSearch}
                onChange={(e) => setDropSearch(e.target.value)}
                onMouseDown={(e) => e.stopPropagation()}
                onClick={(e) => e.stopPropagation()}
                placeholder={`Search ${title.toLowerCase()}...`}
                autoFocus
              />
            </label>
          </div>
          <div className="cs-dropdown-list">
            {isArray && !hasActiveSearch && filteredOptions.length > 1 && (
              <button
                className="cs-dropdown-item select-all"
                onClick={(e) => {
                  e.preventDefault();
                  if (isAllSelected)
                    setFilters({ ...filters, [filterKey]: [] });
                  else setFilters({ ...filters, [filterKey]: [...options] });
                }}
              >
                <div
                  className={`cs-checkbox-ui ${isAllSelected ? "checked" : ""}`}
                >
                  {isAllSelected && (
                    <I.Check
                      style={{ width: "10px", height: "10px", color: "#fff" }}
                    />
                  )}
                </div>
                <span>Select all</span>
              </button>
            )}
            {noSearchResults ? (
              <div className="cs-dropdown-empty">
                No matching results for &ldquo;{query}&rdquo;
              </div>
            ) : (
              filteredOptions.map((opt, index) => {
                const isSelected = isArray
                  ? selectedVals.includes(opt)
                  : selectedVals === opt;
                return (
                  <button
                    key={`${filterKey}-${opt}-${index}`}
                    className={`cs-dropdown-item ${!isArray && isSelected ? "selected" : ""}`}
                    onClick={(e) => {
                      e.preventDefault();
                      toggleFilter(filterKey, opt);
                      if (!isArray) setActiveDropdown(null);
                    }}
                  >
                    {isArray ? (
                      <div
                        className={`cs-checkbox-ui ${isSelected ? "checked" : ""}`}
                      >
                        {isSelected && (
                          <I.Check
                            style={{
                              width: "10px",
                              height: "10px",
                              color: "#fff",
                            }}
                          />
                        )}
                      </div>
                    ) : null}
                    <span>{opt}</span>
                  </button>
                );
              })
            )}
          </div>
        </div>
      )}
    </div>
  );
};
